module.exports = __webpack_public_path__ + "Roboto-regular.f84cb1bf9be983133497.woff2";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src590146077/src/src/assets/fonts/roboto/fonts/Roboto-regular/Roboto-regular.woff2
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-regular/Roboto-regular.woff2
// module chunks = main styles